import React from 'react';
import { LogoAthletic, LogoBody } from '../assets/logos';

const Logo = ({ brandSelect = null }) => {
    const brand = brandSelect ? brandSelect : localStorage.getItem("current_brand");
    return (
        <>
        {
            ['1', '3'].includes(brand?.toString())?
                <LogoBody />:
                <LogoAthletic />
        }
        </>
    )
}

export default Logo;